import { type FC } from 'react';

import { useSvgId } from '../../hooks/use-svg-id';

import { type IconProps } from './types';

export const ProfileV4Icon: FC<IconProps> = () => {
  const { id, idUrl } = useSvgId();

  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={idUrl}>
        <rect x="1" y="1" width="32" height="32" rx="16" fill="#2DB0AB" fillOpacity="0.03" />
        <path
          d="M11.4348 14.9301C11.4348 11.847 13.9265 9.34766 17.0001 9.34766C20.0736 9.34766 22.5653 11.847 22.5653 14.9301C22.5653 18.0132 20.0736 20.5125 17.0001 20.5125C13.9265 20.5125 11.4348 18.0132 11.4348 14.9301Z"
          fill="#00FFBB"
        />
        <path
          d="M14.2175 23.2262C9.60708 23.2262 5.86963 26.9753 5.86963 31.5999C5.86963 33.1415 7.11545 34.3911 8.65224 34.3911H25.3479C26.8847 34.3911 28.1305 33.1415 28.1305 31.5999C28.1305 26.9753 24.3931 23.2262 19.7827 23.2262H14.2175Z"
          fill="#00FFBB"
        />
      </g>
      <rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#00FFBB" strokeOpacity="0.16" />
      <defs>
        <clipPath id={id}>
          <rect x="1" y="1" width="32" height="32" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
